var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3 16h5.9v6h-6v14h-5.8V22h-5.9v-6h5.9v-2.6c0-2.3.7-5.3 2.2-7A7 7 0 0 1 25 4h4.2v6H25c-1 0-1.7.9-1.7 1.8V16Z"
  })));
};
export default SvgFacebook;